module.exports = __webpack_public_path__ + "img/resources-expo.44c386e8.svg";